module.exports = __webpack_public_path__ + "img/nc.0ddd362b.svg";